module.exports = __webpack_public_path__ + "img/zklogo.9eabdacc.png";